import React, { CSSProperties, useEffect } from 'react';

import { ISelectedCard } from '../../../../global/interfaces';
import { COLORS } from '../../../../utils/colors';

interface EditableTitleProps {
  title: string;
  index: number;
  handleTitleEdit: (index: number, value: string) => void;
  editingTitleIndex: number | null;
  setEditingTitleIndex: (index: number | null) => void;
  selectedCard: ISelectedCard | null;
  handleSelectCard: (event: React.MouseEvent<HTMLDivElement>) => void;
  styles: {
    none: CSSProperties;
    cursor: CSSProperties;
    titleInput: CSSProperties;
  };
  children: React.ReactNode;
  onDragOver?: (e: React.DragEvent<HTMLDivElement>) => void;
  onDrop?: (e: React.DragEvent<HTMLDivElement>) => void;
}
const SectionBlock = ({
  title,
  index,
  handleTitleEdit: onTitleEdit,
  editingTitleIndex,
  setEditingTitleIndex,
  selectedCard,
  handleSelectCard,
  styles,
  children,
  onDragOver,
  onDrop,
}: EditableTitleProps) => {
  useEffect(() => {
    if (!selectedCard) return;

    if (selectedCard.index === index) {
      setTimeout(() => {
        const element = document.getElementById(`card_index_${index}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 100);
    }
  }, [selectedCard]);

  return (
    <div
      id={`card_index_${index}`}
      key={index}
      style={
        selectedCard?.index === index // && selectedCard.obj.type === 'Prompt'
          ? {
              ...styles.none,
              border: `.125rem solid ${COLORS.PRIMARY}`,
              borderRadius: '.5rem',
            }
          : {}
      }
      onClick={handleSelectCard}
      onDragOver={onDragOver}
      onDrop={onDrop}>
      {title !== '' &&
        (editingTitleIndex === index ? (
          <input
            style={{
              ...styles.titleInput,
              backgroundColor: 'white',
              display: 'block',
            }}
            autoFocus
            defaultValue={title}
            onBlur={(e) => {
              onTitleEdit(index, e.target.value);
              setEditingTitleIndex(null);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onTitleEdit(index, e.currentTarget.value);
                setEditingTitleIndex(null);
              } else if (e.key === 'Escape') {
                setEditingTitleIndex(null);
              }
            }}
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          <h1
            style={{
              margin: '1rem 1rem .5rem 1rem',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              console.log(':::::onClick', e.target, index);
              e.stopPropagation();
              setEditingTitleIndex(index);
            }}>
            {title}
          </h1>
        ))}
      <div
        style={{
          fontSize: '0.93rem',
          padding: '0 1rem 1rem 1rem',
          lineHeight: 1.72,
        }}>
        {children}
      </div>
    </div>
  );
};

export default SectionBlock;
